import { jsx } from 'react/jsx-runtime';
import { useModalContext } from './hooks.js';
import 'react';
import 'styled-components';
import '../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import 'lodash';
import ThemedComponentWrapper from '../../../theme/ThemedComponentWrapper.js';
import '../../icons/ActivityIcon.js';
import '../../icons/ArrowDownIcon.js';
import '../../icons/ArrowDownRightCircleIcon.js';
import '../../icons/ArrowLeftAlignIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightAlignIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/ArrowSwitchIcon.js';
import '../../icons/ArrowUpIcon.js';
import '../../icons/ArrowUpRightCircleIcon.js';
import '../../icons/ArrowsAngleExpandIcon.js';
import '../../icons/BankIcon.js';
import '../../icons/CheckIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CopyIcon.js';
import CrossIcon from '../../icons/CrossIcon.js';
import '../../icons/DaiIcon.js';
import '../../icons/DangerIcon.js';
import '../../icons/DownSortIcon.js';
import '../../icons/ExclamationTriangleIcon.js';
import '../../icons/ExpandKpiIcon.js';
import '../../icons/EyeIcon.js';
import '../../icons/EyeSlashIcon.js';
import '../../icons/Grid1x2Icon.js';
import '../../icons/InfoCircleIcon.js';
import '../../icons/ListIcon.js';
import '../../icons/LockIcon.js';
import '../../icons/MediumIcon.js';
import '../../icons/MoonIcon.js';
import '../../icons/PiggyBankIcon.js';
import '../../icons/QuestionMarkCircleIcon.js';
import '../../icons/ShieldIcon.js';
import '../../icons/SunIcon.js';
import '../../icons/UpSortIcon.js';
import '../../icons/XIcon.js';
import '../../icons/InfinityIcon.js';
import '../../icons/ArrowUpRightBoxIcon.js';

function ModalClose({ ref, ...props }) {
    const { setOpen } = useModalContext();
    return (jsx(ThemedComponentWrapper, { ...props, ref: ref, onClick: () => setOpen(false), name: "modalClose", children: jsx(CrossIcon, { size: "1" }) }));
}

export { ModalClose as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTW9kYWxDbG9zZS5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvbW9sZWN1bGVzL01vZGFsL01vZGFsQ2xvc2UudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZU1vZGFsQ29udGV4dCB9IGZyb20gJy4vaG9va3MnO1xuaW1wb3J0IHsgVGhlbWVkQ29tcG9uZW50V3JhcHBlciB9IGZyb20gJ0B0aGVtZSc7XG5pbXBvcnQgeyBUaGVtZWRDb21wb25lbnRXcmFwcGVyUHJvcHMgfSBmcm9tICcuLi8uLi8uLi90aGVtZS9UaGVtZWRDb21wb25lbnRXcmFwcGVyJztcbmltcG9ydCB7IENyb3NzSWNvbiB9IGZyb20gJ0BpY29ucyc7XG5cbmV4cG9ydCBpbnRlcmZhY2UgTW9kYWxDbG9zZVByb3BzIGV4dGVuZHMgUGFydGlhbDxUaGVtZWRDb21wb25lbnRXcmFwcGVyUHJvcHM+IHt9XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIE1vZGFsQ2xvc2UoeyByZWYsIC4uLnByb3BzIH06IE1vZGFsQ2xvc2VQcm9wcykge1xuICBjb25zdCB7IHNldE9wZW4gfSA9IHVzZU1vZGFsQ29udGV4dCgpO1xuXG4gIHJldHVybiAoXG4gICAgPFRoZW1lZENvbXBvbmVudFdyYXBwZXJcbiAgICAgIHsuLi5wcm9wc31cbiAgICAgIHJlZj17cmVmfVxuICAgICAgb25DbGljaz17KCkgPT4gc2V0T3BlbihmYWxzZSl9XG4gICAgICBuYW1lPVwibW9kYWxDbG9zZVwiPlxuICAgICAgPENyb3NzSWNvbiBzaXplPVwiMVwiIC8+XG4gICAgPC9UaGVtZWRDb21wb25lbnRXcmFwcGVyPlxuICApO1xufVxuIl0sIm5hbWVzIjpbIl9qc3giXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQU9jLFNBQVUsVUFBVSxDQUFDLEVBQUUsR0FBRyxFQUFFLEdBQUcsS0FBSyxFQUFtQixFQUFBO0FBQ25FLElBQUEsTUFBTSxFQUFFLE9BQU8sRUFBRSxHQUFHLGVBQWUsRUFBRTtBQUVyQyxJQUFBLFFBQ0VBLEdBQUEsQ0FBQyxzQkFBc0IsRUFBQSxFQUFBLEdBQ2pCLEtBQUssRUFDVCxHQUFHLEVBQUUsR0FBRyxFQUNSLE9BQU8sRUFBRSxNQUFNLE9BQU8sQ0FBQyxLQUFLLENBQUMsRUFDN0IsSUFBSSxFQUFDLFlBQVksRUFDakIsUUFBQSxFQUFBQSxHQUFBLENBQUMsU0FBUyxFQUFBLEVBQUMsSUFBSSxFQUFDLEdBQUcsRUFBRyxDQUFBLEVBQUEsQ0FDQztBQUU3Qjs7OzsifQ==
